var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeonInmobiliariaIconsArrow2Forward = function SvgLeonInmobiliariaIconsArrow2Forward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".leon-inmobiliaria-icons-arrow-2-forward_svg__st0{display:none}.leon-inmobiliaria-icons-arrow-2-forward_svg__st1{display:inline}.leon-inmobiliaria-icons-arrow-2-forward_svg__st1,.leon-inmobiliaria-icons-arrow-2-forward_svg__st2{fill:currentcolor}.leon-inmobiliaria-icons-arrow-2-forward_svg__st3{display:inline}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "leon-inmobiliaria-icons-arrow-2-forward_svg__st2",
    d: "m68.3 31-3.2 3.2L82 51H11v4h71.6L65.1 72.5l3.2 3.1 22.3-22.3z",
    id: "leon-inmobiliaria-icons-arrow-2-forward_svg__Arrow_02"
  })));
};
export default SvgLeonInmobiliariaIconsArrow2Forward;